import React from 'react';
import {NavLink} from "react-router-dom";

const regexSpecialCharacter = /\W+/g;

const NavBarMenuItem = ({header}) => (

    <li className="nav-item"
        key={header.LINK.replace(regexSpecialCharacter, '') === '' ? '&nbsp;' : header.DISPLAY_VALUE}
        id={header.LINK.replace(regexSpecialCharacter, '') === '' ? '&nbsp;' : header.DISPLAY_VALUE}>

        <NavLink to={header.LINK}
                 className={navData => navData.isActive ? 'nav-link active' : 'nav-link'}
                 style={{cursor: 'pointer'}} end>
            {header.DISPLAY_VALUE}
        </NavLink>

    </li>
);

export default React.memo(NavBarMenuItem);
